// extracted by mini-css-extract-plugin
export var boxItems = "_7i-1";
export var boxItemsLg = "_7i-2";
export var button = "_7i-7";
export var buttonHoverless = "_7i-9";
export var buttonLg = "_7i-8";
export var filterGroupBox = "_7i-0";
export var icon = "_7i-3";
export var iconSecondary = "_7i-6";
export var iconWrapper = "_7i-4";
export var iconWrapperLg = "_7i-5";
export var truncatedLabel = "_7i-a";